import { Component } from 'react';
import { connect } from 'react-redux';
import TextMap from '../../helpers/TextMap';
import Analytics from '../../helpers/analytics/analytics';

export default class BasePage extends Component {

  constructor(props) {
    super(props);

    this.textMap = new TextMap();
    this.analytics = new Analytics();
    this.state = { mounted: false };

    // This binds all internal functions labled as "handler" to "this"

    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (name.toLowerCase().indexOf('handle') >= 0 && (this[name] instanceof Function)) {
        this[name] = this[name].bind(this);
      }
    }
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    this.resized = true;
    this.setState({ resized: !this.state.resized });
  }

  setWhiteLabels(currentCompany) {
    if (currentCompany) {
      if (!currentCompany.white_labels) {
        currentCompany.white_labels = [];
      }
      if ((this.currentCompany != currentCompany && currentCompany.white_labels) || (this.currentCompany && this.currentCompany.white_labels != currentCompany.white_labels)) {
        this.currentCompany = currentCompany;
        this.textMap.reset();
        for (let i = 0; i < currentCompany.white_labels.length; i++) {
          const label = currentCompany.white_labels[i];
          this.textMap[label.field] = label.value;
        }
      }
    }
  }

  componentDidMount() {
    this.setState({ mounted: true });
    // window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize)
    this.setState({ mounted: false });
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    needsLogin: state.main.needsLogin,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};

connect(mapStateToProps, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/baseClasses/BasePage/index.js